import React, { FC } from 'react';
// eslint-disable-next-line no-restricted-imports
import { QueryClient, QueryClientProvider as BaseQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { createTestQueryClient } from '@/test-utils';
import { ToastControllerProvider } from 'components/Common/Toast';

const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5000,
    },
  },
});

const isTest = () => process.env.NODE_ENV === 'test' || Boolean(window?.Cypress);
export const getQueryClient = () => (isTest() ? createTestQueryClient() : defaultQueryClient);

export const QueryClientProvider: FC = ({ children }) => {
  return (
    <BaseQueryClientProvider client={getQueryClient()}>
      <ToastControllerProvider>{children}</ToastControllerProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </BaseQueryClientProvider>
  );
};
